import { List } from 'antd';
import styled, { css } from 'styled-components';

export const ListItem = styled(List.Item)<{ $active: boolean }>`
  position: relative;
  background: ${p => (p.$active ? p.theme.activeItemBackground : undefined)};
  padding-left: 24px;
  padding-right: 24px;
  overflow: hidden;
  border-right: ${p =>
    p.$active ? `3px solid ${p.theme.primary}` : undefined};
  .ant-list-item-meta-description,
  .ant-list-item-meta-title {
    color: ${p => (p.$active ? p.theme.primary : undefined)};
  }
  .ant-list-item-action {
    margin-right: -8px;
  }
`;

export const VisibilityListItemWrapper = styled.div<{
  $isVisible: boolean;
}>`
  background-color: #fff;
  .ant-btn-link {
    opacity: 0;
    transition: opacity 0.3s;
  }
  &:hover {
    background-color: #f7f7f7;
    .ant-btn-link {
      opacity: 1;
    }
  }

  ${props =>
    props.$isVisible
      ? css`
          transition: max-height 0.3s 0s, visibility 0.3s 0.3s,
            opacity 0.3s 0.3s, background-color 0.3s;
          visibility: visible;
          max-height: 300px;
          opacity: 1;
        `
      : css`
          transition: max-height 0.3s 0.3s, visibility 0.3s 0s, opacity 0.3s 0s,
            background-color 0.3s;
          visibility: hidden;
          max-height: 0px;
          opacity: 0;
        `};
`;
